// contexts/AppContext.tsx

import { hexToRgbArray } from '@src/utils/common';
import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';
import type { Magazine, Navigation } from './graphql/generated';

export interface PowerBrandingColors {
  bg?: number[];
  fg?: number[];
  surface?: number[];
  primary?: number[];
}

export const defaultBrandingColors = {
  bg: hexToRgbArray('#000000'),
  fg: hexToRgbArray('#FFFFFF'),
  surface: hexToRgbArray('#181818'),
  primary: hexToRgbArray('#FF0000'),
};

export interface AppContextType {
  header: {
    navigation: Navigation;
  };
  search?: {
    searchVisible: boolean;
    setSearchVisible: Dispatch<SetStateAction<boolean>>;
  };
  footer?: {
    navigation: Navigation;
  };
  magazines?: Magazine[];
  theme?: {
    colors: PowerBrandingColors;
    setColors: Dispatch<SetStateAction<PowerBrandingColors>>;
  };
}

// Create context with default value
const AppContext = createContext<AppContextType | null>(null);

export default AppContext;

// Custom hook for using the context
export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppContext.Provider');
  }
  return context;
}
